import(/* webpackMode: "eager" */ "/home/buyme-stg/htdocs/stg.buyme.lk/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThirdPartyAd"] */ "/home/buyme-stg/htdocs/stg.buyme.lk/src/components/ThirdPartyAd.tsx");
